(() => {
  const megaDetails = document.querySelectorAll(".js-mega-detail");
  let activeMegaDetail = null;

  function closeMegaMenu() {
    if (activeMegaDetail) {
      activeMegaDetail.removeAttribute("open");
      activeMegaDetail = null;
    }
  }

  megaDetails.forEach((megaDetail) => {
    megaDetail.addEventListener("mouseenter", () => {
      // Use "mouseenter" instead of "mouseover"
      if (activeMegaDetail && activeMegaDetail !== megaDetail) {
        closeMegaMenu(); // Close the previously active mega menu
      }
      megaDetail.setAttribute("open", "true");
      activeMegaDetail = megaDetail;
    });
  });

  document.addEventListener("mousemove", (event) => {
    if (!activeMegaDetail) return;

    const megaDetailRect = activeMegaDetail.getBoundingClientRect();
    const mouseY = event.clientY;
    const mouseX = event.clientX;
    let megaHeight;
    const detailsElement = document.querySelector('details[open="true"]');
    if (detailsElement) {
      const megaMenuContentElement = detailsElement.querySelector(
        ".mega-menu__content"
      );
      if (megaMenuContentElement) {
        megaHeight = megaMenuContentElement.offsetHeight;
      }
    }

    // Close the menu if the mouse is outside the bounds of the megaDetail
    if (
      mouseY < megaDetailRect.top ||
      (mouseX < megaDetailRect.left && mouseY <= megaDetailRect.top) ||
      (mouseX > megaDetailRect.right && mouseY <= megaDetailRect.top) ||
      mouseY > 2.5 * megaDetailRect.top + megaHeight
    ) {
      closeMegaMenu();
    }
  });
})();
